// extracted by mini-css-extract-plugin
export default {"someClass":"Greeting_someClass__espCj","error":"Greeting_error__aN5zh"};